// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281049/js/" + chunkId + "." + {"44":"c1099a9b","225":"bc701717","481":"5aa92454","486":"d875be77","770":"063bf31b"}[chunkId] + ".0.3161088451552715.chunk.js";
};